import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VueYouTubeEmbed from 'vue-youtube-embed'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCodeHighlight from 'vue-code-highlight'
import 'vue-code-highlight/themes/prism-tomorrow.css'

library.add(faDownload)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueCodeHighlight)

Vue.use(VueYouTubeEmbed)

Vue.use(Buefy)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
